import { logEvent } from 'firebase/analytics';
import { analytics } from './firebase';

const track = (event, params) => {
  try { logEvent(analytics, event, params); } catch {}
};

export const trackLogin      = (method)  => track('login',          { method });
export const trackSignUp     = (method)  => track('sign_up',        { method });
export const trackScanReceipt = ()       => track('scan_receipt');
export const trackAddExpense = (category) => track('add_expense',   { category });
export const trackExport     = (format)  => track('export_report',  { format });
export const trackBeginCheckout = (plan) => track('begin_checkout', { plan });
